import {
  Star,
  Flame,
  Rocket,
  Gem,
  Zap,
  Globe,
  Building,
  Wallet,
  TrendingUp,
  AlertTriangle,
} from "lucide-react";
import { deriveCapitalUSD, deriveRiskScore } from "./opportunityDerived";

/**
 * Data-driven semantic labels for an opportunity.
 * Order matters — earlier labels take precedence in scan-order rendering.
 */
export const LABEL_DEFINITIONS = [
  {
    key: "golden",
    label: "فرصة ذهبية",
    icon: Star,
    tone: "opportunity",
    predicate: (o, m) => o.score >= 90 && (m.confidence ?? 0) >= 90,
  },
  {
    key: "premium",
    label: "بريميوم",
    icon: Gem,
    tone: "intel",
    predicate: (o, m) => {
      const cap = deriveCapitalUSD(m);
      return cap !== null && cap >= 50_000_000;
    },
  },
  {
    key: "high-potential",
    label: "إمكانية عالية",
    icon: TrendingUp,
    tone: "opportunity",
    predicate: (o, m) => m.status === "high-potential",
  },
  {
    key: "high-growth",
    label: "نمو مرتفع",
    icon: Rocket,
    tone: "opportunity",
    predicate: (o) =>
      ["الذكاء الاصطناعي", "الطاقة المتجددة", "التقنية المالية"].includes(
        o.industry,
      ) && o.score >= 80,
  },
  {
    key: "trending",
    label: "رائجة",
    icon: Flame,
    tone: "warning",
    predicate: (o) =>
      o.type === "إشارة السوق المبكرة" || o.type === "القطاع الصاعد",
  },
  {
    key: "fast",
    label: "تنفيذ سريع",
    icon: Zap,
    tone: "warning",
    predicate: (o, m) => m.timeSensitivity === "urgent",
  },
  {
    key: "global",
    label: "نطاق واسع",
    icon: Globe,
    tone: "intel",
    predicate: (o, m) => m.marketImpact === "national",
  },
  {
    key: "local",
    label: "نطاق محلي",
    icon: Building,
    tone: "intel-soft",
    predicate: (o, m) => m.marketImpact === "local",
  },
  {
    key: "low-capital",
    label: "رأس مال منخفض",
    icon: Wallet,
    tone: "opportunity",
    predicate: (o, m) => {
      const cap = deriveCapitalUSD(m);
      return cap !== null && cap < 10_000_000;
    },
  },
  {
    key: "high-risk",
    label: "مخاطر مرتفعة",
    icon: AlertTriangle,
    tone: "risk",
    predicate: (o, m) => deriveRiskScore(m) >= 4,
  },
];

/** Return labels that apply to an opportunity. */
export const deriveLabels = (opportunity) => {
  const meta = opportunity?.meta ?? {};
  return LABEL_DEFINITIONS.filter((d) => d.predicate(opportunity, meta));
};
